import React, { useEffect, useMemo, useState } from "react";
import { default as Table } from "react-base-table";
import "react-base-table/styles.css";
import {
  Button,
  Col,
  Form,
  FormControl,
  Row,
  Spinner,
  Modal,
} from "react-bootstrap";
import { toast } from "react-toastify";
import {
  getDateWithTimezone,
  getFormattedDate,
} from "../form-generator/helpers/utility";
import { createMapsLinkFromJobs } from "../helpers/global";
import { CalendarDate } from "react-bootstrap-icons";

const onInputValueChanges = (
  e,
  job,
  field,
  columnPrimaryKey,
  setInvalidField,
  onValueChange
) => {
  let value = e.target.value;
  if (field.type === "checkbox") {
    value = e.target.checked;
  }
  if (field.type === "date") {
    value = getDateWithTimezone(e.target.value);
  }
  if (field.type === "number") {
    value = Number(e.target.value);
  }
  if (field.type === "checkbox-date") {
    const dateField =
      field.key === "invoiceSent" ? "invoiceSentDate" : "invoicePaidDate";
    if (e.target.hasOwnProperty("checked")) {
      const checked = e.target.checked;
      const dateValue = e.target.value
        ? getDateWithTimezone(e.target.value)
        : null;

      onValueChange({
        ...job,
        [field[columnPrimaryKey]]: checked,
        [dateField]: checked ? dateValue : null,
      });
      return;
    } else {
      value = e.target.value ? getDateWithTimezone(e.target.value) : null;
      onValueChange({
        ...job,
        [dateField]: value,
      });
      return;
    }
  }
  if (field.validator && field.validateOnChange) {
    // Validating fields and setting validation msg
    const { isValid, message } = field.validator(value);
    !isValid
      ? setInvalidField({
          field: field[columnPrimaryKey],
          jobId: job["_id"],
          message,
        })
      : setInvalidField(null);
  }

  onValueChange({ ...job, [field[columnPrimaryKey]]: value });
};

const InputField = ({
  field,
  backgroundColor = "",
  columnPrimaryKey,
  disabled,
  job,
  value,
  invalidField,
  setInvalidField,
  onValueChange,
}) => {
  const validationMsg = useMemo(() => {
    if (
      invalidField &&
      invalidField.field === field.label &&
      invalidField.jobId === job["_id"]
    )
      return invalidField.message;
  }, [invalidField, field, job]);

  if (field.type === "date") {
    const date = new Date(value);
    value = getFormattedDate(date);
  }

  return (
    <>
      {field.type === "text" ||
      field.type === "date" ||
      field.type === "number" ? (
        <>
          <FormControl
            size="sm"
            title={validationMsg}
            disabled={disabled}
            type={field.type}
            className={`tinner-text px-1 ${
              backgroundColor ? `text-white` : "text-dark"
            } ${validationMsg && "border-danger"}`}
            style={{ backgroundColor, width: field.width - 5 }}
            value={value}
            max={field?.max}
            min={field?.min}
            onChange={(e) =>
              onInputValueChanges(
                e,
                job,
                field,
                columnPrimaryKey,
                setInvalidField,
                onValueChange
              )
            }
          />
          {/* {invalid &&
            invalid.field === field.label &&
            invalid.jobId === job["ID"] && (
              <h6 className="tinner-text text-danger mb-0 mt-1">
                {invalid.message || "Invalid Value"}
              </h6>
            )}{" "} */}
        </>
      ) : field.type === "checkbox" ? (
        <Form.Check
          type={field.type}
          disabled={disabled}
          checked={value}
          onChange={(e) =>
            onInputValueChanges(
              e,
              job,
              field,
              columnPrimaryKey,
              setInvalidField,
              onValueChange
            )
          }
        />
      ) : field.type === "checkbox-date" ? (
        <CheckboxWithDate
          field={field}
          disabled={disabled}
          job={job}
          columnPrimaryKey={columnPrimaryKey}
          onValueChange={onValueChange}
          validationMsg={validationMsg}
          setInvalidField={setInvalidField}
        />
      ) : (
        <select
          value={value}
          disabled={disabled}
          style={{ backgroundColor, width: field.width - 5 }}
          className={`form-control form-control-sm tinner-text px-1 m-auto ${
            backgroundColor ? `text-white` : "text-dark"
          }`}
          onChange={(e) =>
            onInputValueChanges(
              e,
              job,
              field,
              columnPrimaryKey,
              setInvalidField,
              onValueChange
            )
          }
        >
          {field?.options?.map((option, index) => {
            return (
              <option
                key={index}
                value={typeof option === "object" ? option?._id : option}
              >
                {typeof option === "object"
                  ? option?.name || option?.label || ""
                  : option}
              </option>
            );
          })}
        </select>
      )}
    </>
  );
};

const UrlField = ({
  field,
  job,
  columnPrimaryKey,
  disabled,
  color,
  onClickFunction,
}) => {
  const { icon, label, valueModifier } = field;
  const link = valueModifier(job);
  return (
    <>
      {label === "Appr Image" ? (
        job["appraisalImageId"] ? (
          <a href={link} target="_blank">
            <Button
              disabled={disabled}
              variant={`outline-${color}`}
              style={{ width: field.width - 5 }}
              className="px-1 py-1 d-flex justify-content-center align-item-center"
            >
              {icon(job)}
            </Button>
          </a>
        ) : (
          <Button
            variant={`outline-${color}`}
            disabled={disabled}
            style={{ width: field.width - 5 }}
            className="px-1 py-1 d-flex justify-content-center align-item-center"
            onClick={() => onClickFunction(job)}
          >
            {icon(job)}
          </Button>
        )
      ) : link ? (
        <a href={link} target="_blank">
          <Button
            variant={`outline-${color}`}
            style={{ width: field.width - 5 }}
            disabled={disabled}
            className="px-1 py-1 d-flex justify-content-center align-item-center"
          >
            {icon(job)}
          </Button>
        </a>
      ) : (
        "-"
      )}
    </>
  );
};

const TextField = ({ field, job, color = "black" }) => {
  const text = field.valueModifier(job);
  return (
    <div
      style={{
        width: field.width,
        marginTop: 3,
      }}
    >
      <span
        style={{
          color,
        }}
      >
        {text === null || text === undefined ? "N/A" : text}
      </span>
    </div>
  );
};

const CheckboxWithDate = ({
  field,
  disabled,
  job,
  columnPrimaryKey,
  onValueChange,
  setInvalidField,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ checked: false, date: "" });

  const dateField =
    field.key === "invoiceSent" ? "invoiceSentDate" : "invoicePaidDate";

  const defaultDate = () => getFormattedDate(new Date());

  const openModal = (checked = false, date = "") => {
    setModalData({
      checked,
      date: checked ? date || defaultDate() : null,
    });
    setShowModal(true);
  };

  const handleCheckboxChange = (checked) => {
    openModal(checked, defaultDate());
  };

  const handleEditMode = () => {
    if (!disabled) {
      openModal(
        !!job[field[columnPrimaryKey]],
        new Date(job[dateField]).toLocaleDateString("en-CA")
      );
    }
  };

  const handleSave = () => {
    const { checked, date } = modalData;

    const syntheticEvent = {
      target: {
        checked,
        value: checked ? date : null,
      },
    };

    onInputValueChanges(
      syntheticEvent,
      job,
      field,
      columnPrimaryKey,
      setInvalidField,
      onValueChange
    );

    setShowModal(false);
  };

  return (
    <div className="position-relative d-inline-block">
      {job[dateField] ? (
        <CalendarDate
          size={14}
          style={{
            cursor: disabled ? "not-allowed" : "pointer",
            color: "green",
          }}
          onClick={handleEditMode}
        />
      ) : (
        <Form.Check
          type="checkbox"
          disabled={disabled}
          checked={false}
          onChange={(e) => handleCheckboxChange(e.target.checked)}
        />
      )}

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="sm"
        backdrop="static"
      >
        <Modal.Header
          closeButton
          className="py-2 px-3 d-flex align-items-center"
        >
          <div className="w-100 d-flex align-items-center justify-content-between">
            <h6 className="mb-0 small-text">{field.label} Status</h6>
          </div>
        </Modal.Header>
        <Modal.Body className="d-flex flex-column gap-3">
          <h6 className="mb-1 small-text fw-bold d-flex align-items-center gap-2">
            <Form.Check
              type="checkbox"
              disabled={disabled}
              checked={modalData.checked}
              onChange={(e) =>
                setModalData((prev) => ({
                  ...prev,
                  checked: e.target.checked,
                  date: e.target.checked ? defaultDate() : null,
                }))
              }
            />
            {field.label}
          </h6>
          <div>
            <h6 className="mb-2 small-text fw-bold d-flex align-items-center gap-2">
              <CalendarDate size={16} />
              {field.key === "invoiceSent"
                ? "Invoice Sent Date"
                : "Invoice Paid Date"}
            </h6>
            <Form.Control
              type="date"
              value={modalData.date || ""}
              onChange={(e) =>
                setModalData((prev) => ({
                  ...prev,
                  date: e.target.value,
                }))
              }
              disabled={!modalData.checked}
              className="rounded-2"
              size="sm"
            />
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 d-flex justify-content-end p-3 pt-0">
          <Button
            variant="outline-secondary"
            onClick={() => setShowModal(false)}
            size="sm"
            className="me-2"
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            size="sm"
            disabled={disabled}
            onClick={handleSave}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const TCell = ({
  field,
  columnPrimaryKey,
  rowData,
  disabled,
  color,
  onRowChange,
  onFileUploadClick,
  invalidField,
  setInvalidField,
}) => {
  return (
    <div className="text-center">
      {field.category === "text" ? (
        <TextField
          field={field}
          columnPrimaryKey={columnPrimaryKey}
          job={rowData}
          disabled={disabled}
          color={color}
        />
      ) : field.category === "url" ? (
        <UrlField
          field={field}
          job={rowData}
          columnPrimaryKey={columnPrimaryKey}
          disabled={false}
          color={color}
          onClickFunction={onFileUploadClick}
        />
      ) : (
        <InputField
          field={field}
          backgroundColor={color}
          job={rowData}
          columnPrimaryKey={columnPrimaryKey}
          value={rowData[field[columnPrimaryKey]] ?? ""}
          onValueChange={onRowChange}
          disabled={disabled}
          invalidField={invalidField}
          setInvalidField={setInvalidField}
        />
      )}
    </div>
  );
};

const DataSheet = ({
  columns = [],
  data = [],
  updatedData = [], // Only changed obj
  editMode,
  primaryKey = "_id",
  rowColor,
  onRowChange,
  columnColor,
  onCancelClick,
  onEditClick,
  onSave,
  onFileUploadClick,
  validationField,
  loadMoreData,
  columnPrimaryKey = "key",
  fetchingMoreJobs,
  buttonDisabled,
  height,
}) => {
  const [invalidField, setInvalidField] = useState([]);
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const fieldsToValidate = useMemo(() => {
    return columns.filter((field) =>
      validationField.map((f) => f.field).includes(field.label)
    );
  }, [columns, validationField]);

  const handleDataSave = async () => {
    for (const obj of updatedData) {
      for (const fieldToCheck of fieldsToValidate) {
        const { label, validator, key } = fieldToCheck;
        const { isValid, message } = validator(obj[key]);

        if (!isValid) {
          setInvalidField({
            field: label,
            jobId: obj[primaryKey],
            message,
          });
          toast.error(`${label} is invalid.`);
          return;
        } else {
          setInvalidField(null);
        }
      }
    }

    await onSave(
      updatedData.map((ud) => ({
        _id: ud?._id,
        jobUpdates: {
          ...ud,
          latitude: Number(ud?.latitude),
          longitude: Number(ud?.longitude),
        },
      }))
    );
  };
  const onCancel = () => {
    setInvalidField([]);
    onCancelClick();
  };
  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Row className="my-md-2">
        <Col className="text-right">
          <a href={createMapsLinkFromJobs(data)} target="_blank">
            <Button
              className="mr-3 py-0 tiny-text"
              variant="outline-info"
              size="sm"
            >
              View All in Map
            </Button>
          </a>
          {editMode && (
            <Button
              className="mr-3 py-0 tiny-text"
              variant="outline-secondary"
              size="sm"
              onClick={onCancel}
              disabled={buttonDisabled}
            >
              Cancel
            </Button>
          )}
          <Button
            className="py-0"
            variant="outline-primary tiny-text"
            size="sm"
            disabled={buttonDisabled}
            onClick={editMode ? handleDataSave : onEditClick}
          >
            {editMode ? "Save" : "Edit"}
          </Button>
        </Col>
      </Row>
      <div className="w-100">
        <Table
          fixed
          data={data}
          backgroundColor="white"
          width={viewportWidth - 60}
          height={height}
          onEndReached={loadMoreData}
          onEndReachedThreshold={1000}
          className="px-2"
          headerHeight={60}
          rowKey={primaryKey}
          rowHeight={40}
          footerRenderer={() =>
            fetchingMoreJobs && (
              <div className="d-flex justify-content-center align-items-center w-100 mt-1 loading-more-spinner">
                <Spinner animation="border" />
              </div>
            )
          }
          footerHeight={fetchingMoreJobs ? 50 : 0}
          rowClassName={({ rowData }) => {
            const updated = updatedData?.find(
              (d) => d[primaryKey] === rowData[primaryKey]
            );
            return updated ? "bg-primary-flat" : "";
          }}
        >
          {columns.map((field) => {
            return (
              <Table.Column
                key={field.label}
                title={field.shortLabel || field.label}
                dataKey={field[columnPrimaryKey]}
                width={field.width + 5}
                frozen={field.sticky && "left"}
                headerClassName={"bg-primary text-white"}
                className="px-2"
                align="center"
                editMode={editMode}
                invalidField={invalidField}
                style={{
                  fontSize: 10,
                }}
                cellRenderer={({
                  rowData,
                  column: { editMode, invalidField },
                }) => {
                  const color =
                    columnColor(rowData, field) || rowColor(rowData);
                  return (
                    <TCell
                      field={field}
                      columnPrimaryKey={columnPrimaryKey}
                      rowData={rowData}
                      disabled={!editMode}
                      color={color}
                      onRowChange={onRowChange}
                      onFileUploadClick={onFileUploadClick}
                      invalidField={invalidField}
                      setInvalidField={setInvalidField}
                    />
                  );
                }}
              />
            );
          })}
        </Table>
      </div>
    </>
  );
};

export default DataSheet;
